import SiteLayout from "@/components/feature/SiteLayout";
import { usePageMeta } from "@/hooks/usePageMeta";
import HeroCarousel from "./components/HeroCarousel";
import PriceOverview from "./components/PriceOverview";
import NewsHighlight from "./components/NewsHighlight";
import TopicsSection from "./components/TopicsSection";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  usePageMeta({
    title: "黄金—权威黄金行情与投资指导平台",
    description:
      "黄金网站为您提供最新黄金价格行情、市场分析及投资资讯，覆盖黄金现货、期货等多种产品，助您科学把握投资机会。",
    keywords: "黄金,黄金价格,黄金行情,投资黄金,黄金市场,黄金资讯,贵金属,黄金走势",
  });

  return (
    <SiteLayout>
      <h1 className="sr-only">黄金 - 权威黄金行情与投资指导平台</h1>
      <HeroCarousel />
      <PriceOverview />
      <NewsHighlight />
      <TopicsSection />
      <SiteIntro />
    </SiteLayout>
  );
}